import api from "./api"
import type { OversightReverseGeocode, OversightGoogleMapsApiKey } from "./types"

const GOOGLE_MAPS_RESOURCE = 'google_maps'

export const reverseGeocode = async (latitude: number, longitude: number) => {
  return await api.get<OversightReverseGeocode>(`${GOOGLE_MAPS_RESOURCE}/reverse_geocode`, { latitude, longitude })
}

export const getMapsApiKey = async () => {
  return await api.get<OversightGoogleMapsApiKey>(`${GOOGLE_MAPS_RESOURCE}/maps_api_key`)
}